import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '开户信息'
  }, {
    componentType: 'el-select',
    componentName: '下拉选择',
    fieldKey: 'type',
    fieldName: '类型',
    url: 'UserPayType',
    selectType: 1,
    option: []
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'branchName',
    fieldName: '账户昵称'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'account',
    fieldName: '账号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'content',
    fieldName: '备注'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'defaultValue',
    fieldName: '默认账户'
  }
]
